module.exports = __webpack_public_path__ + "img/Frame-24.ab0433db.svg";